import VueRouter from 'vue-router'
import Service, { deviceTypes } from './Service'
const subPage = {
  template: '<router-view></router-view>'
}

export default class extends VueRouter {
  constructor (arg) {
    super(arg)
    this.redirect({
      '/matrix/:mac': '/matrix/:mac/mapping',
      '/power/:mac': '/power/:mac/status',
      '/mixer/:mac': '/mixer/:mac/status',
      '/dio/:mac': '/dio/:mac/status',
      '/control/:mac': '/control/:mac/mapping',
      '/splitter/:mac': '/splitter/:mac/status',
      '/mes/:mac': '/mes/:mac/port-status'
    })

    this.map({
      '/login': {
        component: require('./pages/Login.vue'),
        noauth: true,
        noloading: true
      },
      '/welcome': {
        name: 'nodev',
        component: require('./pages/Welcome.vue'),
        noloading: true
      },
      '/test': {
        component: require('./pages/test/test.vue'),
        noloading: true,
        noauth: true,
        name: 'test'
      },
      '/installer_list': {
        component: require('./pages/other/installerList.vue'),
        name: 'installerList',
        noloading: true
      },
      '/': {
        component: {
          template: '',
          ready () {
            this.$router.goToIndex()
          }
        }
      },
      '/matrix/:mac': {
        name: 'matrix',
        component: subPage,
        subRoutes: {
          '/mapping': {
            component: require('./pages/matrix/Mapping.vue')
          },
          '/preset': {
            component: require('./pages/matrix/Memory.vue')
          },
          '/EDID': {
            component: require('./pages/matrix/Edid.vue')
          },
          '/setting': {
            component: require('./common/Setting.vue')
          },
          '/log': {
            component: require('./common/Log.vue')
          },
          '/m2m': {
            component: require('./pages/M2M.vue')
          },
          '/HDCP': {
            component: require('./common/HDCP.vue')
          },
          '/system': {
            component: require('./common/System.vue')
          },
          '/schedule': {
            component: require('./pages/matrix/Schedule.vue')
          }
        }
      },
      '/power/:mac': {
        name: 'power',
        component: subPage,
        subRoutes: {
          '/status': {
            component: require('./pages/power/Status.vue')
          },
          '/analysis': {
            component: require('./pages/power/Analysis.vue')
          },
          '/schedule': {
            component: require('./pages/power/Schedule.vue')
          },
          '/setting': {
            component: require('./common/Setting.vue')
          },
          '/log': {
            component: require('./common/Log.vue')
          },
          '/event': {
            component: require('./pages/power/Event.vue')
          },
          '/system': {
            component: require('./common/System.vue')
          },
          '/m2m': {
            component: require('./pages/M2M.vue')
          }
        }
      },
      '/mixer/:mac': {
        name: 'mixer',
        component: subPage,
        subRoutes: {
          '/layout': {
            isLayout: true,
            component: require('./pages/mixer/Layout.vue')
          },
          '/status': {
            component: require('./pages/mixer/Status.vue')
          },
          '/setting': {
            component: require('./common/Setting.vue')
          },
          '/log': {
            component: require('./common/Log.vue')
          },
          '/preset': {
            component: require('./pages/mixer/Profile.vue')
          },
          '/m2m': {
            component: require('./pages/M2M.vue')
          },
          '/system': {
            component: require('./common/System.vue')
          },
          '/HDCP': {
            component: require('./common/HDCP.vue')
          },
          '/EDID': {
            component: require('./pages/matrix/Edid.vue')
          },
          '/schedule': {
            component: require('./pages/matrix/Schedule.vue')
          }
        }
      },
      '/splitter/:mac': {
        name: 'splitter',
        component: subPage,
        subRoutes: {
          '/status': {
            component: require('./pages/videoWall/Status.vue')
          },
          '/layout': {
            component: require('./pages/videoWall/Layout.vue')
          },
          '/setting': {
            component: require('./common/Setting.vue')
          },
          '/log': {
            component: require('./common/Log.vue')
          }
        }
      },
      '/dio/:mac': {
        name: 'dio',
        component: subPage,
        subRoutes: {
          '/status': {
            component: require('./pages/dio/Status.vue')
          },
          '/schedule': {
            component: require('./pages/dio/Schedule.vue')
          },
          '/event': {
            component: require('./pages/dio/Event.vue')
          },
          '/setting': {
            component: require('./common/Setting.vue')
          },
          '/log': {
            component: require('./common/Log.vue')
          }
        }
      },
      '/control/:mac': {
        name: 'control',
        component: subPage,
        subRoutes: {
          '/mapping': {
            component: require('./pages/hdmi/iframe.vue')
          }
        }
      },
      '/mes/:mac': {
        name: 'mes',
        component: subPage,
        subRoutes: {
          '/port-status': {
            component: require('./pages/mes/PortStatus.vue')
          },
          '/setting': {
            component: require('./pages/mes/Setting.vue')
          }
        }
      },
      '/ir/:mac': {
        name: 'ir',
        component: subPage
      }
    })
    // note: beforeEach is a vue function not available to use async
    this.beforeEach(({ to, next, abort }) => {
      if (to.matched === null) {
        console.log('state is null')
        abort()
        this.replace('/')
      } else if (to.noauth) {
        next()
      } else {
        Service.getAuthState().then(state => {
          if (state) {
            if (to.params.mac) {
              Service.getDeviceRefForRouter().on('value', snap => {
                let userCanViewTheTargetDevice = false
                let deviceRef = snap.val()
                // console.log('deviceRef is =====> ', deviceRef)
                for (let mac in deviceRef) {
                  // console.log('mac', mac)
                  if (to.params.mac && mac.toUpperCase() === to.params.mac.toUpperCase()) {
                    userCanViewTheTargetDevice = true
                  }
                }
                console.log('userCanViewTheTargetDevice => ' + to.params.mac, userCanViewTheTargetDevice)
                if (!userCanViewTheTargetDevice) {
                  abort()
                  this.replace('/')
                }
              })
            }
            return next()
          } // end of loggined
          abort()
          this.replace('/login')
        })
      }
    })
  }      // close constructor
  async goToIndex () { // this is for index page asking
    try {
      let dev = await Service.getFirst()
      // undefined when new user, null when state not ready
      if (dev && dev.typeId) {
        console.log('devics in goToIndex', dev)
        this.replace({
          name: deviceTypes[dev.typeId],
          params: {
            mac: dev.mac
          }
        })
      } else {
        this.replace({
          name: 'nodev'
        })
      }
    } catch (err) {
      console.log(err)
      if (err.message !== 'no online') {
        setTimeout(() => this.goToIndex(), 1000)
      }
    }
  }
}     // close class



// WEBPACK FOOTER //
// ./src/Router.js